import type { SelectionExtensionPluginOptions } from '@atlaskit/editor-plugin-selection-extension/types';

interface Props {
	options: SelectionExtensionPluginOptions | undefined;
}

export function selectionExtensionPluginOptions({
	options,
}: Props): SelectionExtensionPluginOptions | undefined {
	return options;
}
